import { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { Button } from 'components/Elements';
import { VerificationCodeInputField } from 'components/Form';
import { loginWithSMSOTP } from '../api/loginWithSMSOTP';
import { verifySMSOTP } from '../api/verifySMSOTP';

export const SMSAuthForm = ({ onSuccess }) => {
  const [loading, setLoading] = useState(true);
  const [verifying, setVerifying] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const [otp, setOTP] = useState('');
  const inputRefs = useRef(new Array(6).fill(null));
  const hasSentOTP = useRef(false); // ✅ Prevent duplicate sends
  const navigate = useNavigate();

  useEffect(() => {
    const sendOTP = async () => {
      if (hasSentOTP.current) return; // ✅ Skip if already sent
      hasSentOTP.current = true;

      try {
        await loginWithSMSOTP();
      } catch (err) {
        console.error('Failed to send OTP:', err);
        setError('Failed to send OTP. Please refresh and try again.');
      } finally {
        setLoading(false);
      }
    };

    sendOTP();
  }, []);

  const handleVerify = async () => {
    setVerifying(true);
    setError('');
    try {
      const response = await verifySMSOTP({ code: otp });

      if (response.user) {
        setSuccess(true);
        onSuccess();
      }
    } catch (err) {
      setError('Invalid verification code. Please try again.');
    } finally {
      setVerifying(false);
    }
  };

  return (
    <div>
      {loading ? (
        <div className="text-sm text-gray-500">Sending OTP...</div>
      ) : (
        <>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            A 6-digit code has been sent to your mobile number.
          </label>
          <div className="flex space-x-2 justify-start mb-3 w-full">
            <VerificationCodeInputField
              length={6}
              onChange={(code) => setOTP(code)}
            />
          </div>

          {error && <div className="text-sm text-red-600 mb-2">{error}</div>}

          <div className="w-full">
            <Button
              className="w-full mb-3"
              onClick={handleVerify}
              disabled={verifying || otp.length !== 6}
            >
              {verifying ? 'Verifying...' : 'Verify'}
            </Button>
          </div>
        </>
      )}
    </div>
  );
};

export default SMSAuthForm;
